module.exports = __webpack_public_path__ + "static/img/unit_riskbg.c3ca5bb7.png";